/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { create } from 'zustand';

/**
 * Toast state store.
 */
export interface ToastStore {
  activeToast: JSX.Element | null;
  updateActiveToast: (newValue: JSX.Element | null) => void;
}

export const useToastStore = create<ToastStore>()((set) => ({
  activeToast: null,
  updateActiveToast: (newValue: JSX.Element | null): void => {
    set({ activeToast: newValue });
  },
}));
